import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiInformalTradeConstants } from "../../constants/api-constants/api-informal-trade.constants";
let InformalTradeService = class InformalTradeService {
    http;
    constructor(http) {
        this.http = http;
    }
    getApplicationSetBaysObservable(applicationId, params) {
        return this.http.post(`${ApiInformalTradeConstants.URL}/${applicationId}/${ApiInformalTradeConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    setTradersObservable(jobId, params) {
        return this.http.post(`${ApiInformalTradeConstants.URL}/${jobId}/${ApiInformalTradeConstants.FUNCTION_SET_TRADERS}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    getInformalTradeApplicationObservable(params) {
        return this.http.get(ApiInformalTradeConstants.URL, { params })
            .pipe(map((response) => {
            return response.value;
        }));
    }
    setTradingObservable(applicationId, tradeGoodsParams) {
        return this.http.post(`${ApiInformalTradeConstants.URL}/${applicationId}/${ApiInformalTradeConstants.FUNCTION_SET_TRADE_GOODS}`, tradeGoodsParams)
            .pipe(map((response) => {
            return response;
        }));
    }
    getTradersObservable(jobId) {
        return this.http.get(`${ApiInformalTradeConstants.URL}/${jobId}/${ApiInformalTradeConstants.FUNCTION_GET_TRADERS}`)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
InformalTradeService = __decorate([
    Injectable({
        providedIn: "root"
    })
], InformalTradeService);
export { InformalTradeService };
